export default '/build/37f28134.svg'